/**
 * @file
 * Search toggle functionality.
 */

(function (Drupal) {
  'use strict';

  Drupal.behaviors.searchToggle = {
    attach: function (context) {
      const searchBlock = context.querySelector('.search-block');

      if (!searchBlock) return;

      const toggleBtn = searchBlock.querySelector('.search-block__toggle');
      const closeBtn = searchBlock.querySelector('.search-block__close');
      const formContainer = searchBlock.querySelector('.search-block__form-container');
      const searchInput = formContainer?.querySelector('input[type="search"], input[type="text"]');

      if (!toggleBtn || !closeBtn || !formContainer) return;

      // Add BEM class to input if it exists
      if (searchInput && !searchInput.classList.contains('search-block__input')) {
        searchInput.classList.add('search-block__input');
      }

      // Add BEM class to submit button if it exists
      const submitBtn = formContainer.querySelector('button[type="submit"], input[type="submit"]');
      if (submitBtn && !submitBtn.classList.contains('search-block__submit')) {
        submitBtn.classList.add('search-block__submit');
      }

      // Open search
      toggleBtn.addEventListener('click', () => {
        formContainer.hidden = false;
        formContainer.classList.add('search-block__form-container--visible');
        formContainer.classList.remove('search-block__form-container--closing');
        toggleBtn.classList.add('search-block__toggle--hidden');
        toggleBtn.setAttribute('aria-expanded', 'true');
        closeBtn.classList.remove('search-block__toggle--hidden');

        // Focus the input
        setTimeout(() => {
          searchInput?.focus();
        }, 100);
      });

      // Close search
      const closeSearch = () => {
        // Add closing class to trigger slide-out animation
        formContainer.classList.add('search-block__form-container--closing');
        toggleBtn.classList.remove('search-block__toggle--hidden');
        toggleBtn.setAttribute('aria-expanded', 'false');
        closeBtn.classList.add('search-block__toggle--hidden');

        // Wait for animation to complete before hiding
        setTimeout(() => {
          formContainer.classList.remove('search-block__form-container--visible');
          formContainer.classList.remove('search-block__form-container--closing');
          formContainer.hidden = true;
        }, 300);
      };

      closeBtn.addEventListener('click', closeSearch);

      // Close on ESC key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && formContainer.classList.contains('search-block__form-container--visible')) {
          closeSearch();
        }
      });

      // Close when clicking outside
      document.addEventListener('click', (e) => {
        if (formContainer.classList.contains('search-block__form-container--visible') &&
          !searchBlock.contains(e.target)) {
          closeSearch();
        }
      });
    }
  };
})(Drupal);
